import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { GlobalOptionForm } from "src/routes/libraries/global-options-v2/GlobalOptionForm";
import { GlobalOptionsPageV2 } from "src/routes/libraries/global-options-v2/GlobalOptionsPageV2";
import { GlobalOptionsPage } from "src/routes/libraries/global-options/GlobalOptionsPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as globalOptionsPaths from "src/routing/domains/libraries/global-options/globalOptionsPaths";

/**
 * `/libraries/global-options*` route tree.
 *
 * Role: data router domain route.
 *
 * Stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page (legacy `PageHeader` chrome).
 *
 * Note: `globalOptionsLegacyRoute` is a sibling prefix (`/libraries/global-options-legacy`), registered
 * as its own top-level tree below so it is not nested under `/libraries/global-options`.
 */
export const globalOptionsRoutes: RouteObject[] = [
  {
    path: globalOptionsPaths.globalOptionsRoute.path,
    Component: AppShell,
    children: [
      {
        Component: GlobalNavLayout,
        children: [
          {
            Component: ScrollableParentLayout,
            children: [
              { index: true, Component: GlobalOptionsPageV2 },
              { path: globalOptionsPaths.globalOptionRoute.path, Component: GlobalOptionForm },
            ],
          },
        ],
      },
      { path: "*", Component: NotFound },
    ],
  },
  {
    path: globalOptionsPaths.globalOptionsLegacyRoute.path,
    Component: AppShell,
    children: [
      {
        Component: GlobalNavLayout,
        children: [{ Component: ScrollableParentLayout, children: [{ index: true, Component: GlobalOptionsPage }] }],
      },
      { path: "*", Component: NotFound },
    ],
  },
];
